import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { COMMISSION_UPLOAD_STATUS } from '../enums';

@Pipe({
  name: 'commissionUploadStatus'
})
export class CommissionUploadStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = COMMISSION_UPLOAD_STATUS;
}
